<template>
  <form 
    class="search" 
    :style="{background: colorBg}"
    method="GET"
    @submit.prevent="irResultadosBusqueda()"
  >
      <input 
        type="text"
        class="search__txt"
        v-model="kword"
        :placeholder="searchHolder"
        :style="{color: color}"
        @click="showResults= !showResults">
      <button
        type="submit"
        class="search__btn"
        :style="{background: colorBtn}">
          Buscar
      </button>
      <ul v-if="listaResultados.length > 0 " class="search__results">
        <li 
          class="search__results__item"
          v-for="competicion in listaResultados"
          :key="competicion.id">
            <router-link 
              :to="{ name: link, params: {'usernameCompetition':  competicion.competition.username }}"
              class="search__results__item__link">
                <span style="font-weight: bold;">{{ competicion.name }}</span> - {{ competicion.competition.name }}
            </router-link>
        </li>
      </ul>
  </form>
</template>

<script>

  import { torneoSearch } from '@/api/Torneo'
  import _ from 'lodash'

  export default {
    name: 'AppSimpleSearchTorneo',
    props: {
      color: String,
      colorBg: String,
      colorBtn: String,
      searchHolder: String,
      link: String,
      linkAll: String
    },
    data() {
      return {
        showResults: false,
        kword: '',
        listaResultados: []
      }
    },
    methods: {
      debouceSearchTorneo: _.debounce(function (val) {
        this.serachResultados(val)
      }, 300),
      serachResultados: function (kword) {
        torneoSearch(kword).then(
          (response) => {
            this.listaResultados = response.data.results
          }
        )
      },
      irResultadosBusqueda: function () {
        this.$router.push({name: this.linkAll, query: { kword: this.kword }})
      }
    },
    watch: {
      kword: function (val) {
        this.debouceSearchTorneo(val)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &__txt {
      display: block;
      width: 60%;
      margin: 0px 10px;
      height: 35px;
      padding: 5px 10px;
      border-radius: 10px;
      font-size: 12px;
      font-family: $ff-4;
      background-color: #dfe6e9;
      &:focus {
        outline: none;
      }
      @include desde($large) {
        height: 40px;
      }
    }
    &__btn {
      height: 35px;
      width: 100px;
      color: $color-white;
      font-family: $ff-4;
      border-radius: 10px;
      font-size: 12px;
      &:hover {
        cursor: pointer;
        opacity: 0.6;
      }
      @include desde($large) {
        font-size: 16px;
        width: 150px;
        height: 40px;
      }
    }
    &__results {
      display: block;
      position: absolute;
      background: $color-white;
      box-shadow: 5px 5px 8px -6px $color-1;
      width: 90%;
      height: 150px;
      overflow-y: auto;
      bottom: -145px;
      list-style: none;
      margin: 0px;
      padding: 10px;
      border-radius: 10px;
      z-index: 1000;
      @include desde($large) {
        width: 75%;
        height: 180px;
        bottom: -175px;
      }
      &__item {
        display: block;
        &__link {
          display: block;
          padding: 5px;
          text-decoration: none;
          color: $color-1;
          font-family: $ff-2;
          &:hover {
            background: $color-8;
          }
          @include desde($large) {
            padding: 10px;
          }
        }
      }
    }
  }
</style>